// Actions

import axios from '@/axios.js'

export default {
  GetList ({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/sms_template/list',
        params,
        method: 'GET'
      })
      .then(res => {
        resolve(res.data.payload)
      })
      .catch(err => {
        reject(err)
      })
    })
  },
  GetFilterList({commit}, status) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/sms_template/list?status=${status}`,
        method: 'GET'
      })
        .then(res => {
          resolve(res.data.payload)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  Approve ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/sms_template/${payload}/approve`,
        data: {},
        method: 'PATCH'
      })
      .then(res => {
        if (res.data) {
          resolve(res.data)
        }
      })
      .catch(err => reject(err))
    })
  },
  Add({ commet }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/sms_template',
        data: payload,
        method: 'POST'
      })
      .then(res => {
        if (res.data) {
          resolve(res.data)
        }
      })
      .catch(err => reject(err))
    })
  },
  Reject ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/sms_template/${payload}/reject`,
        data: {},
        method: 'PATCH'
      })
      .then(res => {
        if (res.data) {
          resolve(res.data)
        }
      })
      .catch(err => reject(err))
    })
  },
  GetSmsTemplateById ({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/sms_template/${id}`,
        method: 'GET'
      })
        .then(res => {
          if (res.data) {
            resolve(res.data)
          }
        })
        .catch(err => reject(err))
    })
  },
  UpdateSmsTemplate ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/sms_template/${payload.sms_template_uuid}`,
        data: payload,
        method: 'PATCH'
      })
        .then(res => {
          if (res.data) {
            resolve(res.data)
          }
        })
        .catch(err => reject(err))
    })
  },
  Delete ({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/sms_template/${id}`,
        method: 'DELETE'
      })
        .then(res => {
          if (res.data) {
            resolve(res.data)
          }
        })
        .catch(err => reject(err))
    })
  },
}
